import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative float-right" }
const _hoisted_2 = { class: "flex flex-row-reverse" }

import { computed, onMounted, reactive, watch } from "vue";
import Modal from "@/components/common/Modal.vue";
import { useStore } from "vuex";
import VueTableLite from "vue3-table-lite/ts";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { ReportTemplateGetters } from "@/store/modules/reportTemplate/getters";
import { ReportTemplateActions } from "@/store/modules/reportTemplate/actions";
import Button from "@/components/common/Button.vue";
import { HandIcon, TrashIcon } from "@heroicons/vue/outline";
import { useToast } from "vue-toastification";
import { SYSTEM_REPORT_TEMPLATE_TYPES } from "@/types/report/ReportTypes";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean,
    required: true,
  },
  reportType: {
    type: String,
    default: null,
  },
  systemOnly: {
    type: Boolean,
    default: false,
  },
},
  emits: ["select", "close"],
  setup(__props, { emit }) {

const props = __props





const store = useStore();
const toast = useToast();

const dataProvider = computed(
  () => store.getters[ReportTemplateGetters.GET_DATA_PROVIDER]
);

const filteredItems = computed(() => {
  const items = dataProvider.value.items;

  if (props.reportType) {
    return items.filter(
      (item: { reportType: string }) => item.reportType === props.reportType
    );
  }

  if (props.systemOnly) {
    return items.filter((item: { reportType: string }) =>
      SYSTEM_REPORT_TEMPLATE_TYPES.includes(item.reportType)
    );
  }

  return items;
});

const pager = computed(() => dataProvider.value.pager);

const table = reactive({
  isLoading: false,
  columns: [
    {
      label: t("reports.name"),
      field: "name",
      sortable: false,
    },
    {
      label: t("reports.templateType"),
      field: "reportType",
      sortable: false,
    },
    {
      label: "",
      field: "action",
      sortable: false,
    },
  ],
  rows: filteredItems,
  totalRecordCount: 0,
});

const clickHandler = (data: unknown) => {
  emit("select", data);
};

const removeHandler = async (id: string) => {
  const confirmed = confirm(t("reports.deleteTemplateConfirm"));
  if (!confirmed) {
    return;
  }

  await store.dispatch(ReportTemplateActions.DELETE, id);
  await store.dispatch(ReportTemplateActions.FETCH_DATA_PROVIDER, { page: 1 });
  toast.success(t("reports.templateDeleted"));
};

const getPage = async (page: number) => {
  await store.dispatch(ReportTemplateActions.FETCH_DATA_PROVIDER, { page });
};

watch(
  () => props.show,
  async (isShown) => {
    if (!isShown) {
      return;
    }

    await getPage(1);
  }
);

onMounted(async () => {
  await getPage(1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    title: _unref(t)('reports.savedReports'),
    show: __props.show,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close', false)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(VueTableLite), {
        "data-pagination-scroll-anchor": "",
        "is-slot-mode": true,
        "is-loading": _unref(table).isLoading,
        columns: _unref(table).columns,
        rows: _unref(table).rows,
        total: _unref(table).totalRecordCount,
        sortable: false,
        "is-hide-paging": true,
        messages: { noDataAvailable: _unref(t)('common.noData') }
      }, {
        reportType: _withCtx((data) => [
          _createTextVNode(_toDisplayString(data.value.reportType), 1)
        ]),
        action: _withCtx((data) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Button, {
              onClick: ($event: any) => (clickHandler(data))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(HandIcon), { style: {"width":"22px"} })
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(Button, {
              class: "ml-2",
              onClick: ($event: any) => (removeHandler(data.value.id))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TrashIcon), { style: {"width":"22px"} })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["is-loading", "columns", "rows", "total", "messages"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TablePagination, {
          current: _unref(pager).currentPage,
          "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_unref(pager).currentPage) = $event)),
          "total-pages": _unref(pager).totalPages,
          "onUpdate:total-pages": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pager).totalPages) = $event)),
          "start-page": _unref(pager).startPage,
          "end-page": _unref(pager).endPage,
          onPageChanged: getPage
        }, null, 8, ["current", "total-pages", "start-page", "end-page"])
      ])
    ]),
    _: 1
  }, 8, ["title", "show"]))
}
}

})